// ua-服务
export default {

    /**
     * userAgent
     */
    ua: navigator.userAgent,

    /**
     * platform
     */
    platform: window.navigator.platform,

    /**
     * 类型
     *
     * @param type 类型 pc：电脑 mobile：移动端
     */
    type(type = '') {
        return new Promise((resolve, reject) => {
            var ua = this.ua;
            if (type == 'pc') {
                if (ua.indexOf("Opera") > -1) {
                    resolve('Opera');
                } else if (ua.indexOf("Firefox") > -1) {
                    resolve('Firefox');
                } else if (ua.indexOf("Chrome") > -1) {
                    resolve('Chrome');
                } else if (ua.indexOf("Safari") > -1) {
                    resolve('Safari');
                } else if (ua.indexOf("compatible") > -1 && ua.indexOf("MSIE") > -1) {
                    resolve('IE');
                } else {
                    resolve('other');
                }
            } else if (type == 'mobile') {
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
                        //本身h5跳转
                        resolve('wechat');
                    } else {
                        //微信小程序
                        resolve('mini');
                    }
                } else {
                    if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
                        //ios
                        resolve('iOS');
                    } else {
                        //安卓
                        resolve('Android');
                    }
                }
            } else {
                if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)) {
                    resolve('mobile');
                } else {
                    resolve('pc');
                }
            }
        })
    },

    /**
     * 浏览器名称版本号
     */
    getBrowser() {
        var UserAgent = navigator.userAgent.toLowerCase();
        var browserInfo = {};
        var browserArray = {
            IE: window.ActiveXObject || "ActiveXObject" in window, // IE
            Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1, // Chrome浏览器
            Firefox: UserAgent.indexOf('firefox') > -1, // 火狐浏览器
            Opera: UserAgent.indexOf('opera') > -1, // Opera浏览器
            Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1, // safari浏览器
            Edge: UserAgent.indexOf('edge') > -1, // Edge浏览器
            QQBrowser: /qqbrowser/.test(UserAgent), // qq浏览器
            WeixinBrowser: /MicroMessenger/i.test(UserAgent) // 微信浏览器
        };
        for (var i in browserArray) {
            if (browserArray[i]) {
                var versions = '';
                if (i == 'IE') {
                    versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)[2];
                } else if (i == 'Chrome') {
                    for (var mt in navigator.mimeTypes) {
                        //检测是否是360浏览器(测试只有pc端的360才起作用)
                        if (navigator.mimeTypes[mt]['type'] == 'application/360softmgrplugin') {
                            i = '360';
                        }
                    }
                    versions = UserAgent.match(/chrome\/([\d.]+)/)[1];
                } else if (i == 'Firefox') {
                    versions = UserAgent.match(/firefox\/([\d.]+)/)[1];
                } else if (i == 'Opera') {
                    versions = UserAgent.match(/opera\/([\d.]+)/)[1];
                } else if (i == 'Safari') {
                    versions = UserAgent.match(/version\/([\d.]+)/)[1];
                } else if (i == 'Edge') {
                    versions = UserAgent.match(/edge\/([\d.]+)/)[1];
                } else if (i == 'QQBrowser') {
                    versions = UserAgent.match(/qqbrowser\/([\d.]+)/)[1];
                }
                browserInfo.type = i;
                browserInfo.versions = versions;
            }
        }
        return browserInfo;
    },
    /*
    系统类型
    */
   clientOs() {
      const sUserAgent = navigator.userAgent
      const isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows')
      const isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel')
      if (isMac) return 'Mac'
      const isUnix = (navigator.platform === 'X11') && !isWin && !isMac
      if (isUnix) return 'Unix'
      const isLinux = (String(navigator.platform).indexOf('Linux') > -1)
      if (isLinux) return 'Linux'
      if (isWin) {
        const isWin2K = sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1
        if (isWin2K) return 'Win2000'
        const isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1
        if (isWinXP) return 'WinXP'
        const isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1
        if (isWin2003) return 'Win2003'
        const isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1
        if (isWinVista) return 'WinVista'
        const isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1
        if (isWin7) return 'Win7'
        const isWinX = sUserAgent.indexOf('Windows NT 10') > -1 || sUserAgent.indexOf('Windows 10') > -1
        if (isWinX) return 'Win10'
      }
      return 'Win8'
   }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/ua.js